// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"66cc216d","791":"5a4c906c"}[chunkId] + ".1793406085688.chunk.css";
};